import { useQuery } from '@tanstack/react-query';
import { TopLevelObjectTypeRepository } from 'services/flex-data/repositories/TopLevelObjectTypeRepository';
import { QueryKeys } from 'utils/queryKeys';
import type { TopLevelObjectType, TopLevelObjectTypeResponse } from './types';

const emptyTopLevelObjectTypes: TopLevelObjectType[] = [];

export const useTopLevelObjectType = (enabled = true) => {
  const { data, isLoading, isError, status } = useQuery({
    queryKey: [QueryKeys.getFlexDataTopLevelObjectTypes],
    queryFn: TopLevelObjectTypeRepository.getTopLevelObjectTypes,
    enabled,
  });
  return {
    isTopLevelObjectTypesLoading: isLoading,
    topLevelObjectTypes: (data as TopLevelObjectTypeResponse | undefined)?.data ?? emptyTopLevelObjectTypes,
    isTopLevelObjectTypesError: isError,
    status,
  };
};
